import { usePost } from '../../../sharedModules/hooks/useQuery';

const RESUME_AUTOMATIC_URL = '/collections/scheduled_emails/resume_automatic';

interface ResumeAutomaticParams {
  location: string;
  bill_code: string;
}

interface ResumeAutomaticResponse {
  resumed: boolean;
  next_send_at: string | null;
}

export function useResumeAutomatic() {
  const mutation = usePost<ResumeAutomaticResponse>();

  const resumeAutomatic = (params: ResumeAutomaticParams) =>
    mutation.mutateAsync({ url: RESUME_AUTOMATIC_URL, data: params });

  return { resumeAutomatic, isLoading: mutation.isPending, isError: mutation.isError };
}
